import React from "react";
import { useNavigate } from "react-router-dom";
import "./TourCard.css";
import { useTranslation } from "./hooks/useTranslation";

const TourCard = ({ title, country, price, duration, tags, image }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleMoreInfoClick = () => {
    if (title === t.package1 || title === "Package 1") {
      navigate("/package1");
    } else if (title === t.package2 || title === "Package 2") {
      navigate("/package2");
    } else if (title === t.package3 || title === "Package 3") {
      navigate("/package3");
    } else if (title === t.package4 || title === "Package 4 (Couples)" || title === "Package 4") {
      navigate("/package4");
    } else if (title === t.package5 || title === "Package 5") {
      navigate("/package5");
    } else if (title === t.completeSriLankaTitle) {
      navigate("/14daytrip");
    } else if (title === t.wildlifeCulturalTitle) {
      navigate("/wildlifetrip");
    } else if (title === t.hillCountryBeachTitle) {
      navigate("/hillbeachtrip");
    } else if (title === t.culturalTriangleBeachTitle) {
      navigate("/culturalbeachtrip");
    } else if (title === t.fiveDayBudgetPackTitle) {
      navigate("/5daytrip");
    } else if (title === t.threeDayColomboCityTitle) {
      navigate("/hello");
    } else if (title === t.familyTripTitle) {
      navigate("/bye");
    } else {
      console.warn("No page defined for this tour:", title);
    }
  };

  return (
    <div className="tour-card animate-fadeIn">
      <div className="tour-image-container">
        <img src={image} alt={title} className="tour-image" />
        <div className="tour-badge">{country}</div>
      </div>
      
      <div className="tour-content">
        <h3 className="tour-title">{title}</h3>
        <div className="tour-stats">
          <span>🕒 {duration} {t.days}</span>
          <span>⭐ 5.0</span>
        </div>
        
        <div className="tour-tags">
          {tags.slice(0, 3).map((tag, index) => (
            <span key={index} className="tour-tag">{tag}</span>
          ))}
        </div>
      </div>

      <div className="tour-footer">
        <div className="tour-price">
          <span className="price-label">{t.from}</span>
          <span className="price-value">${price}</span>
        </div>
        <button className="view-details-btn" onClick={handleMoreInfoClick}>
          {t.viewDetails || "Details"}
        </button>
      </div>
    </div>
  );
};

export default TourCard;
